import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function CloseCircleFillNegativeIcon({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path fillRule="evenodd" clipRule="evenodd"
                d="M16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26ZM10.928 10.7833C11.313 10.3873 11.9372 10.3873 12.3222 10.7833L16.0001 14.5661L19.678 10.7833C20.063 10.3873 20.6872 10.3873 21.0722 10.7833C21.4572 11.1793 21.4572 11.8213 21.0722 12.2172L17.3943 16L21.0722 19.7828C21.4571 20.1787 21.4571 20.8207 21.0722 21.2167C20.6872 21.6127 20.063 21.6127 19.678 21.2167L16.0001 17.434L12.3223 21.2167C11.9373 21.6127 11.3131 21.6127 10.9281 21.2167C10.5431 20.8207 10.5431 20.1787 10.9281 19.7828L14.6059 16L10.928 12.2172C10.543 11.8213 10.543 11.1793 10.928 10.7833Z"
                fill={color}/>
        </svg>
    );
}

export default CloseCircleFillNegativeIcon;
